type UnknownRecord = Record<string, unknown>;

const MODEL_FIELDS = [
  "id",
  "name",
  "global",
  "active",
  "tamarac_name",
  "separate_fixed_income",
  "fixed_income_only",
  "security_set",
  "number_of_stocks",
  "market_segment",
  "country_allocation",
  "top_ten_stocks",
  "regional_allocation",
  "performance_one_year",
  "performance_three_years",
  "performance_five_years",
  "performance_ten_years",
  "performance_since_inception",
  "inception_date",
  "benchmark_model",
  "performance_benchmark_one_year",
  "performance_benchmark_three_years",
  "performance_benchmark_five_years",
  "performance_benchmark_ten_years",
  "performance_benchmark_since_inception",
  "as_of_date",
  "top_ten_stocks_as_of_date",
  "simulated_performance_as_of_date",
  "dow_jones_sector_exposure",
  "dow_jones_sector_exposure_as_of_date",
  "core_model_name",
  "disclosure",
  "one_year_asterisk",
  "three_year_asterisk",
  "five_year_asterisk",
  "ten_year_asterisk",
  "since_inception_asterisk",
  "populate_allocation_model",
  "update_performance",
  "update_top_ten_stocks",
  "update_segments_and_allocations",
  "model_update_source_model_id",
] as const;

const SECURITY_PERFORMANCE_FIELDS = [
  "id",
  "performance_one_year",
  "performance_three_years",
  "performance_five_years",
  "performance_ten_years",
  "performance_since_inception",
  "inception_date",
  "benchmark_fund",
  "performance_benchmark_one_year",
  "performance_benchmark_three_years",
  "performance_benchmark_five_years",
  "performance_benchmark_ten_years",
  "performance_benchmark_since_inception",
  "GICS_sector",
] as const;

function pick(source: UnknownRecord | undefined, fields: readonly string[]): UnknownRecord {
  return Object.fromEntries(
    fields.filter((field) => Object.hasOwn(source || {}, field)).map((field) => [field, source?.[field]]),
  );
}

export function projectModelWritePayload(model: UnknownRecord): UnknownRecord {
  const payload = pick(model, MODEL_FIELDS);
  const allocations = Array.isArray(model.ModelSecurities) ? model.ModelSecurities : [];
  payload.ModelSecurities = allocations.map((input) => {
    const allocation = input && typeof input === "object" && !Array.isArray(input) ? (input as UnknownRecord) : {};
    const projected = pick(allocation, ["id", "security_id", "weight"]);
    if (allocation.Security && typeof allocation.Security === "object" && !Array.isArray(allocation.Security)) {
      projected.Security = pick(allocation.Security as UnknownRecord, SECURITY_PERFORMANCE_FIELDS);
    }
    return projected;
  });
  return payload;
}
